module.exports = __webpack_public_path__ + "img/vpn-8.87546b02.webp";